module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon7.72b8d779.svg";